<template>
  <b-container fluid>
    <b-row class="ctrl-dir">
      <b-col cols="8">
        <alphabet
          v-if="$route.path.includes('/alphabet')"
          :alphabetList="alphabetList">
        </alphabet>
        <grammar
          v-if="$route.path.includes('/grammar')">
        </grammar>
      </b-col>
      <b-col cols="4">
        <div class="w-100 my-5"></div>
        <sidebar-menu
          v-if="alphabetMenuList"
          :menuTitle="ls_Menu"
          :menuList="alphabetMenuList"
          :currentMenu="currentMenu">
        </sidebar-menu>
        <div class="sticky-top">
          <div class="alphabet-examples">
            <p>
              <span class="example-latyndisplay">
                {{ hovertedAlphabet.latynDisplay }}
              </span>
            </p>
            <p class="example-latynexamples">
              {{ hovertedAlphabet.latynExample }}
            </p>
          </div>
          <div class="about-examples">
            <div class="latyn-example">
              <p class="example-content">
                {{ hovertedAlphabet.latynParableContent }}
              </p>
              <p class="example-author">
                {{ hovertedAlphabet.latynParableAuthor }}
              </p>
            </div>
            <div class="cyrl-example">
              <p class="example-content">
                {{ hovertedAlphabet.parableContent }}
              </p>
              <p class="example-author">
                {{ hovertedAlphabet.parableAuthor }}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Grammar from "./latynalphabet/Grammar.vue";
import Alphabet from "./latynalphabet/Alphabet.vue";
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";
export default {
  data() {
    return {
      alphabetList: [],
      hovertedAlphabet: {},
      example: {}
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    menuList() {
      if (this.$store.state.navigationList && this.$store.state.navigationList.length > 0) {
        return this.$store.state.navigationList.filter(n =>
          n.url === "/alphabet"
        )[0].childList;
      }
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    ls_alphabet() {
      return this.$store.state.languagePack.ls_alphabet;
    },

    currentMenu() {
      if (this.menuList) {
        return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
      }
    },

    alphabetMenuList() {
      let alphabetMenus = [];
      if (this.menuList && this.menuList.length > 0) {
        this.menuList.forEach(function(menu) {
          alphabetMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
      }
      return alphabetMenus;
    }
  },

  created() {
    this.getExample();
    this.getAlphabetList();
  },

  watch: {
    alphabetList(newVal, oldVal) {
      if (newVal === oldVal) return;
      this.hovertedAlphabet = newVal[0];
    }
  },

  methods: {
    urlPrefixer(url) {
      return this.$route.params.ln !== undefined
        ? "/" + this.$route.params.ln + url
        : url;
    },

    hovered(alphabet) {
      this.hovertedAlphabet = alphabet;
    },

    playAudio(url) {
      if (url.includes(".mp3")) {
        let audio = new Audio(url);
        audio.addEventListener(
          "load",
          function() {
            audio.play();
          },
          false
        );
        audio.pause();
        audio.play();
      }
    },

    getAlphabetList() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getlatynalphabet", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.alphabetList = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    },

    getExample() {
      var fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getrandomparables", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.example = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  components: {
    alphabet: Alphabet,
    grammar: Grammar,
    "sidebar-menu": SidebarNavigation
  },

  metaInfo() {
    return {
      title: this.ls_alphabet
    };
  }
};
</script>

<style lang="scss" scoped>
.alphabet-examples {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #dddfe2;
  padding: 2rem;
  background-color: #ffffff;

  .example-latyndisplay {
    color: #212525;
    font-size: 2rem;
    font-weight: 700;
  }

  .example-devider {
    color: #212525;
    font-size: 1.5rem;
    font-weight: 700;
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .example-latyndisplay-handwrite {
    color: #212525;
    font-size: 2rem;
    font-weight: 700;
    font-family: 'Caveat Brush', cursive;
  }

  .example-latynexamples {
    color: #212525;
    font-size: 1.5rem;
    font-weight: 600;
  }

  .example-latynexamples-handwrite {
    color: #212525;
    font-size: 1.5rem;
    font-weight: 600;
    font-style: italic;
    font-family: 'Caveat Brush', cursive;
  }
}

.about-examples {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 1px solid #dddfe2;
  padding: 2rem;
  background-color: #ffffff;
  font-family: 'Times New Roman', Times, serif, KazNet;
  font-size: 1.125rem;
  font-weight: 600;
  font-style: italic;

  .example-content {
    font-family: 'Times New Roman', Times, serif, KazNet;
    color: #555555;
  }

  .example-author {
    color: #333333;
    text-align: right;
    font-weight: 700;
  }
}

/* RTL */

.rtl-layout {
  .about-examples {
    .latyn-example {
      .example-author {
        text-align: right;
      }
    }
    .cyrl-example {
      .example-content {
        direction: ltr;
        text-align: right;
      }
      .example-author {
        text-align: left;
      }
    }
  }
}
</style>

<style>
@import "https://fonts.googleapis.com/css?family=La+Belle+Aurore";
.table {
  margin-top: 1rem;
  margin-bottom: 0 !important;
}
.table .cyrl-th,
.table .latyn-th {
  padding: 6px 12px;
  font-size: 18px;
}
.table .latyn-th {
  background-color: #607d8b;
  color: #f6f6f6;
  text-align: center;
  vertical-align: middle;
}
.table .cyrl-th {
  background-color: #7283a7;
  color: #f6f6f6;
  text-align: center;
  vertical-align: middle;
}
.table th.table-devider,
.table td.table-devider {
  width: 1rem;
  padding-right: 0;
  padding-left: 0;
  background-color: #ffffff;
}
.table th,
.table td {
  border-color: #bdbdbd !important;
  border: 1px solid #bdbdbd;
  text-align: center;
  cursor: default;
}
.table thead th.table-devider,
.table tbody td.table-devider {
  border: 0;
  border-right: 1px solid #008496;
  border-left: 1px solid #008496;
}
.table .tr-title th {
  color: #274e6d;
}
.table .alphabet-description:hover {
  background-color: #f0f0f0;
}
.table .alphabet-description .alphabet-index {
  color: #444444;
}
.table .alphabet-description .alphabet-latyndisplay {
  color: #111111;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}
.table .alphabet-description .alphabet-handwrite {
  font-weight: 700;
  font-style: italic;
  font-family: 'Caveat Brush', cursive;
}
.table .alphabet-description .alphabet-latynpronounce {
  color: #777777;
}
.table .alphabet-description .alphabet-sound {
  color: #567a92;
  transition: all 0.7s ease-in-out;
}
.table .alphabet-sound .sound {
  cursor: pointer;
}
.table .alphabet-sound .sound:hover {
  color: #45a8eb;
}
.table .alphabet-sound .sound-audio {
  display: none;
}
.table .alphabet-description .alphabet-cyrldisplay {
  color: #111111;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
}
.table .alphabet-description .alphabet-cyrlpronounce {
  color: #777777;
}
.about-examples .example-content {
  font-family: 'Times New Roman', Times, serif, KazNet;
}
</style>
